(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    const announce = document.querySelector('.announcement-bar-section');
    if (announce) {
      this.announce = announce;
      document.documentElement.style.setProperty('--announce-height', `${announce.offsetHeight}px`);
    } else {
      document.documentElement.style.setProperty('--announce-height', '0px');
    }

    this.headerIsAlwaysSticky = ['always','reduce-logo-size'].includes(this.getAttribute('data-sticky-type'));
    this.headerBounds   = {};
    this.currentScrollTop = 0;
    this.preventReveal  = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

    this.onScrollHandler   = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    }).observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch?.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide()   { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
  reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset()  { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }

  closeMenuDisclosure() { (this.disclosures || (this.disclosures = this.header.querySelectorAll('header-menu'))).forEach(d => d.close()); }
  closeSearchModal()    { /* handled by details-modal */ }
}
customElements.define('sticky-header', StickyHeader);

/* ── Announcement bar dismiss ────────────────────────────────────────────── */
(function() {
  var bar = document.getElementById('hdr-announce');
  var btn = document.getElementById('hdr-announce-close');
  if (!bar || !btn) return;

  /* Use the message text as the key — if message changes, the old
     dismissed state no longer matches and the bar shows again */
  var msgEl = bar.querySelector('.hdr-announce__text');
  var msgHash = msgEl ? msgEl.textContent.trim().slice(0, 60) : 'msg';
  var KEY = 'hdr-announce-dismissed:' + msgHash;

  if (sessionStorage.getItem(KEY) === '1') {
    bar.setAttribute('data-dismissed', 'true');
  }

  btn.addEventListener('click', function() {
    bar.setAttribute('data-dismissed', 'true');
    sessionStorage.setItem(KEY, '1');
  });

  /* Dev note: to force-show the bar during testing, run in console:
     sessionStorage.clear() then reload */
})();

/* ── Mobile drawer: close when tapping outside ──────────────────────────────
─────────────────────────────────────────────────────────────────────────── */
(function () {
  function hdrCloseDrawer() {
    var details = document.getElementById('Details-menu-drawer-container');

    /* Prefer the theme's own close() — it handles aria, scroll lock, classes */
    var headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
      return;
    }

    /* Fallback: click the summary to toggle (most reliable DOM-level close) */
    if (details && details.open) {
      var summary = details.querySelector('summary.header__icon--menu');
      if (summary) { summary.click(); return; }
      /* Last resort: force close details directly */
      details.open = false;
    }

    /* Always ensure body scroll lock classes are removed */
    document.documentElement.classList.remove('overflow-hidden', 'menu-opening');
    document.body.classList.remove(
      'overflow-hidden-tablet', 'overflow-hidden-desktop',
      'menu-is-open', 'js-overlay-open'
    );
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Close on tap/click outside ────────────────────────────────── */
    document.addEventListener('click', function (e) {
      var details = document.getElementById('Details-menu-drawer-container');
      if (!details || !details.open) return;

      var drawer  = document.getElementById('menu-drawer');
      var trigger = document.querySelector('header-drawer');

      if (drawer  && drawer.contains(e.target))  return;
      if (trigger && trigger.contains(e.target)) return;

      hdrCloseDrawer();
    }, false);

    /* ── iOS: also listen on touchend for faster response ───────────── */
    document.addEventListener('touchend', function (e) {
      var details = document.getElementById('Details-menu-drawer-container');
      if (!details || !details.open) return;

      var drawer  = document.getElementById('menu-drawer');
      var trigger = document.querySelector('header-drawer');

      if (drawer  && drawer.contains(e.target))  return;
      if (trigger && trigger.contains(e.target)) return;

      hdrCloseDrawer();
    }, { passive: true });

    /* ── Escape key ─────────────────────────────────────────────────── */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hdrCloseDrawer(); }
    });

  });
})();

/* ── Cart count: instant real-time sync ──────────────────────────────────────
   Updates every cart bubble/counter the moment any item is added to the cart,
   regardless of which add-to-cart mechanism triggers it (AJAX, form submit,
   cart drawer, third-party apps, or our own meals section).
   Strategy: poll /cart.js on every focus/visibility restore + intercept fetch.
─────────────────────────────────────────────────────────────────────────── */
(function() {

  /* ── All selectors used by this theme + common Shopify themes ─────────── */
  var CART_SELECTORS = [
    '.wbhcartitem',
    '[data-cart-count]',
    '.cart-count-bubble',
    '.cart-count-bubble span',
    '.cart-count-bubble > span',
    '#CartCount',
    '.cart__count',
    '[data-cart-item-count]',
    '.header__cart-count',
    '.cart-icon-bubble span',
    '.mobile-bnav__badge',
    '#mobile-bnav-badge'
  ].join(',');

  /* ── Update all cart count elements ──────────────────────────────────── */
  function hdrSetCartCount(count) {
    var els = document.querySelectorAll(CART_SELECTORS);
    els.forEach(function(el) {
      var current = parseInt(el.textContent, 10);
      if (isNaN(current) || current !== count) {
        /* Preserve non-count content in combined-label spans (e.g. "Cart (N)") */
        if (el.querySelector('strong') && el.children.length > 1) {
          var numNode = el.querySelectorAll('strong')[1];
          if (numNode) numNode.textContent = '(' + count + ')';
        } else {
          el.textContent = count;
        }
        /* Pop animation to draw attention to the change */
        el.style.transition = 'transform 0.2s cubic-bezier(0.34,1.56,0.64,1)';
        el.style.transform  = 'scale(1.4)';
        setTimeout(function() { el.style.transform = 'scale(1)'; }, 200);
      }
      /* Show / hide bubble based on count */
      if (count > 0) {
        el.style.display = '';
      } else if (el.classList.contains('mobile-bnav__badge') || el.id === 'mobile-bnav-badge') {
        el.style.display = 'none';
      }
    });
    /* Also update total-price companions when present */
    try {
      document.querySelectorAll('.wbcarthtotal span').forEach(function(){});
    } catch(e){}
    /* Broadcast so other modules (bottom nav, widgets) can react */
    try { document.dispatchEvent(new CustomEvent('sf:cart-count', { detail: { count: count } })); } catch(e){}
  }

  function hdrSetCartTotal(totalPrice, currencySuffix) {
    var nodes = document.querySelectorAll('.wbcarthtotal span, [data-cart-total]');
    if (!nodes.length) return;
    /* Format pennies → £X.XX. Shopify's locale-aware money filter is server-side;
       we fall back to a simple formatter for client refresh. */
    var formatted = (totalPrice / 100).toLocaleString(undefined, {
      style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
    });
    if (currencySuffix) formatted += ' ' + currencySuffix;
    nodes.forEach(function(n){ n.textContent = formatted; });
  }

  /* ── Fetch latest cart state from Shopify ────────────────────────────── */
  function hdrFetchCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      hdrSetCartCount(cart.item_count);
      if (typeof cart.total_price === 'number') {
        hdrSetCartTotal(cart.total_price);
      }
    })
    .catch(function() {});
  }

  /* ── Catch add-to-cart WITHOUT overriding window.fetch ─────────────────
     Overriding window.fetch is unsafe — it can break hero banners, 
     scheduler apps, and any other script that reads response bodies.
     Instead we use a non-invasive XMLHttpRequest open() intercept which
     only reads the URL string (never the response body) plus a form submit
     listener as fallback for traditional add-to-cart forms.
  ──────────────────────────────────────────────────────────────────────── */

  /* URLs that mutate the cart */
  var CART_MUTATION_RX = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;

  /* Intercept XHR (used by many Shopify apps and older theme cart code) */
  var _origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && CART_MUTATION_RX.test(url)) {
      this.addEventListener('load', function() {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(hdrFetchCartCount, 150);
          setTimeout(hdrFetchCartCount, 600);
        }
      });
    }
    return _origXHROpen.apply(this, arguments);
  };

  /* Intercept fetch() for modern cart mutations (safe: we only inspect the
     request URL, never the response body) */
  if (window.fetch && !window.__sfCartFetchPatched) {
    window.__sfCartFetchPatched = true;
    var _origFetch = window.fetch.bind(window);
    window.fetch = function(input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch(e){}
      var isCart = url && CART_MUTATION_RX.test(url);
      var p = _origFetch(input, init);
      if (isCart) {
        p.then(function(resp){
          if (resp && resp.ok) {
            setTimeout(hdrFetchCartCount, 120);
            setTimeout(hdrFetchCartCount, 500);
          }
        }).catch(function(){});
      }
      return p;
    };
  }

  /* Catch traditional HTML form submit */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && CART_MUTATION_RX.test(form.action)) {
      setTimeout(hdrFetchCartCount, 800);
      setTimeout(hdrFetchCartCount, 1800);
    }
  }, true);

  /* ── Post-order reset ───────────────────────────────────────────────────
     When Shopify redirects the customer back from the thank-you page, the
     cart cookie is cleared but cached markup may still show the old count.
     If the referrer is a Shopify checkout host or the URL is the order
     confirmation path, force a refetch after a short delay. */
  try {
    var ref = document.referrer || '';
    var path = window.location.pathname || '';
    if (/\/checkouts?\//i.test(ref) || /\/orders\//.test(path) || /thank_you/i.test(path)) {
      setTimeout(hdrFetchCartCount, 200);
      setTimeout(hdrFetchCartCount, 1200);
    }
  } catch(e){}

  /* ── Listen for Shopify theme events ─────────────────────────────────── */
  var cartEvents = [
    'cart:refresh', 'cart:updated', 'cart:change',
    'product:added',  /* some themes */
    'ajaxProduct:added' /* older themes */
  ];
  cartEvents.forEach(function(evtName) {
    document.addEventListener(evtName, hdrFetchCartCount);
  });

  /* ── Re-sync on tab focus (catches any background cart changes) ──────── */
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) { hdrFetchCartCount(); }
  });
  window.addEventListener('focus', hdrFetchCartCount);

  /* ── Initial sync on page load ───────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hdrFetchCartCount);
  } else {
    hdrFetchCartCount();
  }

})();

/* ── Default search focus handler ────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  var input         = document.querySelector('.search__input');
  var defaultSearch = document.querySelector('.default--search');
  if (!input || !defaultSearch) return;
  var hasChars = false;

  function sync() {
    if (input.value.length > 0) {
      defaultSearch.classList.add('hidden');
      hasChars = true;
    } else if (hasChars) {
      defaultSearch.classList.remove('hidden');
      hasChars = false;
    }
  }
  input.addEventListener('focusin',  function() { if (!input.value.length && !hasChars) defaultSearch.classList.remove('hidden'); });
  input.addEventListener('focusout', function() { if (input.value.length) defaultSearch.classList.add('hidden'); });
  input.addEventListener('keydown',  sync);
  input.addEventListener('input',    sync);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { input.blur(); defaultSearch.classList.add('hidden'); }
  });
  document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && !defaultSearch.contains(e.target)) {
      defaultSearch.classList.add('hidden');
      input.blur();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const onIntersect = (entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(this);
      fetch(this.dataset.url)
        .then(r => r.text())
        .then(htmlText => {
          const temp = document.createElement('div');
          temp.innerHTML = htmlText;
          const pr = temp.querySelector('product-recommendations');
          if (pr && pr.innerHTML.trim().length) {
            this.innerHTML = pr.innerHTML;
          }
        })
        .catch(console.error);
    };
    new IntersectionObserver(onIntersect.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
            class ProductModal extends ModalDialog {
                constructor() {
                super();
                }

                hide() {
                super.hide();
                }

                show(opener) {
                super.show(opener);
                this.showActiveMedia();
                }

                showActiveMedia() {
                this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                    element.classList.remove('active');
                    }
                )
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                    activeMedia.loadContent();
                }
            }

            customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
